import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from 'hooks';
import styles from './user.module.scss';

const User = () => {
  const { user } = useStore();

  return (
    <Link to="/profile" className={styles.user}>
      {user.name}
    </Link>
  );
};

export default User;
